export enum ServiceGroupEnum {
    GENERAL = 'general',
    SOCIAL_TARGET = 'socialTarget',
    OFFERS = 'offers',
    CREDITS = 'credits',
}

export function serviceGroupHasValidity(type: string | any): boolean {
    return [
        ServiceGroupEnum.SOCIAL_TARGET,
        ServiceGroupEnum.CREDITS,
    ].includes(type);
}
